module.exports = __webpack_public_path__ + "static/media/HelveticaNeue-Light.66a149b5.ttf";